import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Button,
    makeStyles,
    Grid,
    TextField
} from "@material-ui/core";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Error } from "../../common/Error";
import { useDispatch } from "react-redux";
import { fieldLabels } from "../../sections/fieldLabels";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { NotInterested } from "@material-ui/icons";
import { closeSoc } from "../../../redux/actions";


const useStyles = makeStyles((theme) => ({
    dialogActions: {
        padding: 15,
    },
    body: {
        marginTop: 5,
        marginBottom: 5,
    },
    unassignBtn: {
        marginRight: "auto",
    },
    changeDetails: {
        padding: 5,
    },

}));

type CloseDialogProps = {
    id: string,
    year: string,
    onClose: () => void;
    open: boolean;
};


export const CloseButtonAndDialog: React.FC<{
    id: string,
    year: string
}> = ({ id, year }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <AppBarButton
                Icon={NotInterested}
                text="Close"
                tooltip="Close soc"
                onClick={() => setIsOpen(true)}
                data-test="close-soc-button"
            />
            {isOpen && (
                <CloseDialog
                    id={id}
                    year={year}
                    onClose={() => setIsOpen(false)}
                    open= {isOpen}
                />
            )}
        </>
    );
};


const CloseDialog: React.FC<CloseDialogProps> = ({
    id,
    year,
    onClose,
    open
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { handleSubmit, control, errors, clearErrors } = useForm({
        defaultValues: {
            closeReason: null,
        },
    });

    const handleCloseDiaglog = (data: { closeReason: string }) => {
        dispatch(closeSoc(id, year, data.closeReason));
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            data-test="close-socv2-dialog"
        >
        <>
            <DialogTitle data-test="close-socv2-dialog-title">
                    Are you sure you want to close this SoC?
                <Divider />
            </DialogTitle>

            <DialogContent>
                <form>
                <Grid container spacing={3}>
                    <Grid xs={12} md={12} lg={12} item>
                        <Controller
                            control={control}
                            name="closeReason"
                            rules={{ required: true }}
                            render={({ onChange }) => (
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={8}
                                    variant="outlined"
                                    label={fieldLabels.closeReason}
                                    data-test="close-reason-field"
                                    required
                                    onChange={(e) => {
                                        if (e.target.value.length > 0) clearErrors("closeReason");
                                        onChange(e);
                                    }}
                                />
                            )}
                        />
                        {errors.closeReason?.type === "required" && (
                            <Error data-test="close-reason-validation">
                                This field is required
                            </Error>
                        )}
                    </Grid>
                </Grid>                </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    onClick={onClose}
                    color="primary"
                    data-test="cancel-close-button-socv2"
                >
                Cancel
                </Button>
                    <Button
                    onClick={handleSubmit(handleCloseDiaglog)}
                    color="primary"
                    data-test="continue-close-button-socv2"
                >
                Continue
                </Button>
            </DialogActions>
        </>
        </Dialog>
    );
};
